/**
 * Created by gaoying on 2017/9/21.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import huke from './modules/huke'

import org from './modules/org'
import user from './modules/user'
import other from './modules/other'

import storeCache from './modules/storeCache'

import classListStore from './modules/classListStore'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    huke,
    org,
    user,
    other,
    storeCache,
    classListStore
  },
  getters
})
